// Input validation utilities following security best practices

export const sanitizeInput = (input: string): string => {
  return input
    .replace(/[<>]/g, '') // Remove potential XSS characters
    .trim();
};

export const formatQueryId = (input: string): string => {
  if (!input) return '';
  return input
    .toLowerCase()
    .replace(/[\s-]/g, '_') // Replace spaces and hyphens with underscores
    .replace(/[^a-z0-9_]/g, ''); // Remove other special characters
};

export const validateQueryId = (queryId: string): boolean => {
  const pattern = /^[a-zA-Z0-9_-]+$/;
  return pattern.test(queryId) && queryId.length >= 3 && queryId.length <= 100;
};

export const validateSQL = (sql: string): { valid: boolean; error?: string } => {
  if (!sql || sql.trim().length === 0) {
    return { valid: false, error: 'SQL content is required' };
  }
  
  if (sql.length > 50000) {
    return { valid: false, error: 'SQL content too long (max 50000 characters)' };
  }
  
  return { valid: true };
};

export const validateCronExpression = (cron: string): boolean => {
  // Basic cron validation (6 fields for Spring cron)
  const parts = cron.trim().split(/\s+/);
  return parts.length === 6;
};

export const validateEmail = (email: string): boolean => {
  const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return pattern.test(email);
};
